// Network-Aggregat für die Cluster-Infra-Card. Aggregiert über alle
// Cluster aus dem gemeinsamen Netz-Stand (netz.svelte.ts):
//   - devices_online: Summe der "online"-Geräte über alle Cluster
//   - devices_total: Summe aller Geräte
//
// Seit 02.11.2026 ohne eigenen Abruf und Takt: die Cluster kommen über das
// Homelab-Protokoll (netz.<id>.cluster, docs/protokoll.md › „Netzwerk über das
// Protokoll“), REST nur beim Start im gemeinsamen Stand. Diese Sicht rechnet die
// Summe und liefert dasselbe Objekt, solange sich die Zahlen nicht ändern.
//
// SWR: ja -- die Cluster kommen beim Start aus der Ablage von netz.svelte.ts.

import { geraeteSumme } from "./netz-protokoll";
import { getNetzCluster, startNetz } from "./netz.svelte";

export interface NetworkSummary {
  devices_online: number;
  devices_total: number;
}

let _off: (() => void) | undefined;
let _letzte: NetworkSummary | undefined;

// Die Summe; ein neues Objekt nur, wenn sich eine Zahl ändert (ein Stand, der
// z. B. nur eine IP ändert, löst sonst jede Karte neu aus).
const _summary = $derived.by((): NetworkSummary | undefined => {
  const cluster = getNetzCluster();
  if (!cluster) return undefined;
  const next = geraeteSumme(cluster);
  if (_letzte && _letzte.devices_online === next.devices_online && _letzte.devices_total === next.devices_total) return _letzte;
  _letzte = next;
  return next;
});

export function startNetworkSummary(): void {
  if (_off) return;
  _off = startNetz();
}

export function stopNetworkSummary(): void {
  _off?.();
  _off = undefined;
}

export function getNetworkSummary(): NetworkSummary | undefined {
  return _summary;
}
